export default {
  NewTask: 'New task',
  TaskEditor: {
    Date: 'Date',
    Cancel: 'Cancel',
    SaveTask: 'Save task',
    AddTask: 'Add task',
    TitlePlaceholder: 'Title',
    DescriptionPlaceholder: 'Description',
    NoMatchesFound: 'No matches found.',
  },
  AssigneePicker: {
    Assignee: 'Assignee',
    SearchPlaceholder: 'Search',
    Tabs: {
      Admin: 'Admin',
      Caregivers: 'Caregivers',
      Clients: 'Clients',
    },
    NoAdminUsersFound: 'No admin users found.',
    NoCaregiversFound: 'No caregivers found.',
    NoClientsFound: 'No clients found.',
  },
  DatePickerQuickOptionCalendar: {
    TypeDatePlaceholder: 'Type a date',
    Today: 'Today',
    Tomorrow: 'Tomorrow',
    ThisWeekend: 'This weekend',
    NextWeek: 'Next week',
    Time: 'Time',
  },
};
